module.exports = __webpack_public_path__ + "static/media/SprinkleZone-logo.7e57437f.svg";